import React from 'react'
import { DateTimeField } from '@mui/x-date-pickers'
import moment from 'moment'
import { isNaN, isNil } from 'lodash'
import PropTypes from 'prop-types'
import { IconButton, InputAdornment } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'

// todo create theme for default props
const DateTimePicker = ({
    label = '',
    value,
    onChange = () => {},
    format = 'DD/MM/YYYY',
    onFocus,
    onBlur,
    focused,
    required,
    disabled,
}) => {
    return (
        <DateTimeField
            format={format}

            label={label}
            value={isNil(value) ? null : moment(value)}
            onChange={v => {
                // Champ vidé au clavier : la date est retirée (comme avec le bouton d'effacement).
                if (isNil(v)) {
                    onChange(undefined)
                    return
                }
                // Saisie partielle ou invalide en cours : on garde la dernière date valide.
                const timestamp = v.valueOf()
                if (isNaN(timestamp)) {
                    return
                }
                onChange(timestamp)
            }}
            disabled={disabled}
            onFocus={onFocus}
            onBlur={onBlur}
            focused={focused}
            error={false}
            required={required}
            slotProps={{
                input: {
                    endAdornment:
                    <InputAdornment position='end'>
                        <IconButton
                            onClick={() => onChange(undefined)}
                            edge='end'
                        >
                            <ClearIcon />
                        </IconButton>
                    </InputAdornment>,
                },
            }}
        />
    )
}

DateTimePicker.propTypes = {
    label: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func,
    format: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    focused: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
}

export default DateTimePicker